import { call, put, all, takeLatest } from 'redux-saga/effects'
import { FETCH_USER_CHATS, UserChatActions } from './actions'
import { getUserChats } from '../../api/userChat'

export function* loadUserChats(action: ReturnType<typeof UserChatActions.fetchUserChats>) {
  try {
    const { limit, offset } = action.payload
    const { data } = yield call(getUserChats, limit, offset)
    yield put(UserChatActions.fetchUserChatsSuccess(data))
  } catch (err) {
    // eslint-disable-next-line no-console
    yield console.log(err)
  }
}

export function* rootSaga() {
  yield all([takeLatest(FETCH_USER_CHATS, loadUserChats)])
}
